/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DaysPerReason
 */
export interface DaysPerReason {
    /**
     * 
     * @type {string}
     * @memberof DaysPerReason
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DaysPerReason
     */
    color: string;
    /**
     * 
     * @type {number}
     * @memberof DaysPerReason
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof DaysPerReason
     */
    totalDays?: number;
}

/**
 * Check if a given object implements the DaysPerReason interface.
 */
export function instanceOfDaysPerReason(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "color" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function DaysPerReasonFromJSON(json: any): DaysPerReason {
    return DaysPerReasonFromJSONTyped(json, false);
}

export function DaysPerReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): DaysPerReason {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'color': json['color'],
        'total': json['total'],
        'totalDays': !exists(json, 'totalDays') ? undefined : json['totalDays'],
    };
}

export function DaysPerReasonToJSON(value?: DaysPerReason | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color': value.color,
        'total': value.total,
        'totalDays': value.totalDays,
    };
}

